module.exports = __webpack_public_path__ + "static/media/catfish.ff897e23.png";